import { render, staticRenderFns } from "./StaffCreateUpdate.vue?vue&type=template&id=41d68dd6"
import script from "./StaffCreateUpdate.vue?vue&type=script&lang=js"
export * from "./StaffCreateUpdate.vue?vue&type=script&lang=js"
import style0 from "./StaffCreateUpdate.vue?vue&type=style&index=0&id=41d68dd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports